import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { ContractTerminationReasonApiService } from './contract-termination-reason.api.service';
import { ContractTerminationReasonEffects } from './contract-termination-reason.effects';
import {
  IContractTerminationReasonState,
  contractTerminationReasonInitialState,
  contractTerminationReasonReducer,
} from './contract-termination-reason.reducer';
import { ContractTerminationReasonService } from './contract-termination-reason.service';
import { contractTerminationReasonFeatureKey } from './types';

@NgModule({
  imports: [
    StoreModule.forFeature<IContractTerminationReasonState>(
      contractTerminationReasonFeatureKey,
      contractTerminationReasonReducer,
      {
        initialState: contractTerminationReasonInitialState,
      },
    ),
    EffectsModule.forFeature([ContractTerminationReasonEffects]),
  ],
  providers: [
    ContractTerminationReasonApiService,
    ContractTerminationReasonService,
  ],
})
export class StoreContractTerminationReasonModule {}
